<template>
  <div id="checkout" class="bo-checkout-body">
    <Spinner v-if="isLoading" />
    <OrderError
      v-if="hasErrors"
      :error="getCurrentErrorMessage"
      :descr="getCurrentErrorDescr"
      :level="getCurrentErrorLevel"
      @onButtonClicked="createNewOrder"
    />
    <article v-else>
      <Header :showFilter="false" />
      <article :class="getBodyClass">
        <h3 v-if="hasItemsInCart === false">
          No hay items agregados en tu pedido aún!
        </h3>
        <p v-if="hasItemsInCart === false">
          Podés agregar volviendo a la página de inicio y seleccionando lo que
          más te guste!
        </p>
        <h4 v-if="hasItemsInCart">Tu pedido:</h4>
        <!-- swipe right section -->
        <div v-if="hasItemsInCart">
          <div v-for="(item, index) in getCartItems" :key="index">
            <SwipeoutItem
              :item="item"
              :index="index"
              @transitionEnd="transitionEnd(index)"
            />
          </div>
        </div>
      </article>
      <FooterCheckout
        nextStep="/CartAddress"
        @onConfirmingOrder="onConfirmingOrder"
        @onOrderConfirmFailure="onOrderConfirmFailure"
        @onOrderConfirmSuccess="onOrderConfirmSuccess"
      />
    </article>
  </div>
</template>
<script>
import Header from "../Components/Header";
import FooterCheckout from "../Components/FooterCheckout";
import OrderError from "../Components/OrderError";
import Spinner from "../Components/Spinner";
import cart_mixin from "../mixins/Cart_Mixin";
import mobile_detection from "../mixins/mobile_detection";
import spinner_mixin from "../mixins/Spinner_Mixin";
import order_error_mixin from "../mixins/OrderError_Mixin";
import SwipeoutItem from "../Components/SwipeoutItem.vue";

export default {
  mixins: [spinner_mixin, order_error_mixin, cart_mixin, mobile_detection],
  name: "checkout",
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("SET_IS_LOADING", false);
    this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
    this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
    this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
    this.processCart();
  },
  methods: {
    transitionEnd(index) {
      this.$store.commit("SET_IS_LOADING", true);
      let selectedProds = this.getSelectedProducts;

      selectedProds.splice(index, 1);

      this.$store.commit("SET_SELECTED_PRODUCTS", selectedProds);
    },
    onConfirmingOrder() {
      this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
      this.$store.commit("SET_IS_LOADING", true);
    },
    onOrderConfirmFailure(message) {
      this.$store.commit(
        "SET_CURRENT_ERROR_MESSAGE",
        "No pudimos confirmar tu pedido :("
      );
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", message);
      this.$store.commit("SET_IS_LOADING", false);
    },
    onOrderConfirmSuccess(response) {
      console.log("Pedido confirmado OK!");
      this.$router.push("ConfirmOrder");
    },
  },
  computed: {
    getBodyClass() {
      if (this.hasItemsInCart) {
        return "bistro-weborders-body-with-items";
      } else {
        return "bistro-weborders-body";
      }
    },
  },
  data() {
    return {};
  },
  components: {
    Header,
    FooterCheckout,
    OrderError,
    Spinner,
    SwipeoutItem,
  },
};
</script>
<style scoped>
.bistro-weborders-body-with-items {
  padding-top: 10vh;
  padding-bottom: 16vh;
  height: 80%;
}
.bistro-weborders-body {
  padding-top: 40vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/Checkout.vue